<template>
  <div class="cart-item">
    <div class="product-info">
      <img @click="$router.push({
                                 name: 'product',
                                 params: {
                                 storeName: $store.storeName,
                                  id: productid  ,
                                   name:name,
                                   lang: $i18n.locale
                                            },
                                   });"
                                   
                                   :src="DBitems.product.image" :alt="DBitems.product.name" class="cart_item_image">
      <div class="product-details">
        <strong class="cart_product_name" @click="$router.push({
                                 name: 'product',
                                 params: {
                                 storeName: $store.storeName,
                                  id: productid  ,
                                   name:name,
                                   lang: $i18n.locale
                                            },
                                   });">{{ DBitems.product.name }}</strong>
                          <br>
        <div  class="product-option" v-if="item.offer_price != 0">
          {{ ((item.offer_price/item.quantity) * $store.state.rate).toFixed($store.state.digit_price) }}
      {{ $store.state.UnitPrice }}</div>
    <div  class="product-option"  v-else>
      {{ ((item.total_price/item.quantity) * $store.state.rate).toFixed($store.state.digit_price) }} {{ $store.state.UnitPrice }}
    </div>
       <div v-if="DBitems.final_options.length != 0">
              <p class="product-option " v-for="(item, index) in DBitems.final_options" :key="index">
                {{ item.option }} : {{ item.value }}
              </p>
            </div>
            <div v-if="DBitems.checkbox_options.length != 0">
              <p  class="product-option"  v-for="(item, index) in DBitems.checkbox_options" :key="index">
                {{ item }}
              </p>
            </div>
      </div>
    </div>
    <div class="quantity-section">
      <div style="display: flex; align-items: center; ">
       <div  class="quantity" style="width: 150px;">
                                <button class="btn btn-outline-secondary" @click="decrementClick()">-</button>
                                <input min="1" name="quantity" :value="item.quantity" title="Qty" type="text"
                                    id="quantityInput" class="form-control text-center small-input" readonly/>
                                <button class="btn btn-outline-secondary" @click="incrementClick()">+</button>
                            </div>
        <div class="remove-btn" style="cursor:pointer;" @click="show = true">
          <i class="bi bi-trash"></i>
        </div>
      </div>
    </div>
     <div class="price " v-if="item.offer_price != 0">{{ ((item.offer_price) * $store.state.rate).toFixed($store.state.digit_price) }}
      {{ $store.state.UnitPrice }}</div>
    <div class="price" v-else>

      {{ ((item.total_price) * $store.state.rate).toFixed($store.state.digit_price) }} {{ $store.state.UnitPrice }}
    </div>
      <Transition name="modal">
    <div v-if="show" class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="header">{{ $t('confirmdelete') }}</slot>
          </div>
          <div class="modal-footer">
            <slot name="footer">
              <button class="modal-default-button close" @click="deleteItem()">{{ $t('confirm') }}</button>
              <button class="modal-default-button" @click="(show = false), $emit('close')">{{ $t('cancel') }}</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </Transition>
  </div>
</template>

<script>
export default {
  props: {
    itemId: String
  },
  data: function () {
    return {
      loading: false,
      DBitems: null,
      item: null,
      show: false
    };
  },
  created() {
    this.loading = true;
    this.item = this.$cookies.get(this.itemId);
    if (this.item != null) {
      //console.log(this.item)
      this.axios
        .post(
          this.$store.state.base_api_url + this.$store.storeName + "/cart_item",
          {
            product_id: this.item.product_id,
            final_option: this.item.final_option,
            option_check: this.item.option_check
          },
          {
            headers: {
              "Accept-Language": this.$i18n.locale
            }
          }
        )
        .then(response => {
          this.DBitems = response.data.data;
          /*if (this.sections.size > 7) {
          if (document.documentElement.getAttribute("dir") === "rtl") {
            this.sections = this.sections.slice().reverse();
          }
        }*/
        })
        .then(() => (this.loading = false));
    }
  },
  methods: {
    incrementClick() {
      // ++this.counterVal;
      console.log(
        "incrementtt" + this.item.quantity + " " + this.item.quantityAll
      );



      //////////////////////////////////////////////////////////
      let S_name_full =
        this.$store.storeName +
        "/" +
        this.item.product_id +
        this.item.final_option +
        this.item.option_check;

      let S_name =
        this.$store.storeName +
        "/" +
        this.item.product_id +
        this.item.final_option;
      console.log("S_name " + S_name);

      let qun = this.item.quantityAll;
      console.log('qun****************', qun)
      let min_qun = this.item.min_quantity;


      let max_qun = this.item.max_quantity;
      console.log("this.item.quantityAll" + this.item.quantityAll);

      let AllCookies = this.$cookies.keys();
      for (let i = 0; i < AllCookies.length; i++) {
        if (AllCookies[i].includes(S_name)) {
          if (AllCookies[i] == S_name_full) {
            console.log("hii i am there ");
          } else {
            qun = qun - this.$cookies.get(AllCookies[i]).quantity;
            min_qun = this.$cookies.get(AllCookies[i]).min_quantity;
            max_qun = this.$cookies.get(AllCookies[i]).max_quantity;
            console.log(
              this.$cookies.get(AllCookies[i]).quantity + " quuuuun " + qun
            );

            console.log(
              this.$cookies.get(AllCookies[i]).min_quantity + " min quuuuun " + min_qun
            );
          }
        }
      }
      //////////////////////////////////////////////////////////
      if (this.item.quantityAll > 0) {
        if (this.item.quantity < qun
          && this.item.quantity < max_qun
          // && this.item.quantity > min_qun
        ) {
          ++this.item.quantity;
          this.item.total_price =
            this.item.total_price / (this.item.quantity - 1) +
            this.item.total_price;
          /*if (this.item.offer_price != 0) {
          this.item.offer_price =
            this.item.total_price -
            (this.item.discount / 100) * this.item.total_price;
        }*/
          if (this.item.offer_price != 0) {
            this.item.offer_price =
              this.item.offer_price / (this.item.quantity - 1) +
              this.item.offer_price;
          }

          //////////update this key
          let product = {
            product_id: this.item.product_id,
            total_price: this.item.total_price,
            offer_price: this.item.offer_price,
            quantity: this.item.quantity,
            quantityAll: this.item.quantityAll,
            min_quantity: this.item.min_quantity,
            max_quantity: this.item.max_quantity,
            final_option: this.item.final_option,
            option_check: this.item.option_check,
            discount: this.item.discount,
            note: this.item.note
          };
          this.$cookies.set(this.itemId, product);
          this.$parent.updateProducts();
        }
      } else {
        ++this.item.quantity;
        this.item.total_price =
          this.item.total_price / (this.item.quantity - 1) +
          this.item.total_price;
        /* if (this.item.offer_price != 0) {
          this.item.offer_price =
            this.item.total_price -
            (this.item.discount / 100) * this.item.total_price;
        }*/
        if (this.item.offer_price != 0) {
          this.item.offer_price =
            this.item.offer_price / (this.item.quantity - 1) +
            this.item.offer_price;
        }

        //////////update this key
        let product = {
          product_id: this.item.product_id,
          total_price: this.item.total_price,
          offer_price: this.item.offer_price,
          quantity: this.item.quantity,
          quantityAll: this.item.quantityAll,
          final_option: this.item.final_option,
          option_check: this.item.option_check,
          discount: this.item.discount,
          note: this.item.note
        };
        this.$cookies.set(this.itemId, product);
        this.$parent.updateProducts();
      }
    },
    decrementClick() {
      let min_qun = this.item.min_quantity;


      let max_qun = this.item.max_quantity;
      console.log(
        "decrementttt" + this.item.quantity + " ", this.item
      );
      if (this.item.quantity > 1
        && (this.item.quantity > min_qun || (min_qun == null))
      ) {
        //  --this.counterVal;
        --this.item.quantity;
        //this.price = this.price/2
        this.item.total_price =
          this.item.total_price -
          this.item.total_price / (this.item.quantity + 1);
        /*if (this.item.offer_price != 0) {
          this.item.offer_price =
            this.item.total_price -
            (this.item.discount / 100) * this.item.total_price;
        }*/
        if (this.item.offer_price != 0) {
          this.item.offer_price =
            this.item.offer_price -
            this.item.offer_price / (this.item.quantity + 1);
        }

        //////////update this key
        let product = {
          product_id: this.item.product_id,
          total_price: this.item.total_price,
          offer_price: this.item.offer_price,
          quantity: this.item.quantity,
          quantityAll: this.item.quantityAll,
          min_quantity: this.item.min_quantity,
          max_quantity: this.item.max_quantity,
          final_option: this.item.final_option,
          option_check: this.item.option_check,
          discount: this.item.discount,
          note: this.item.note
        };
        this.$cookies.set(this.itemId, product);
        this.$parent.updateProducts();
      }
    },
    deleteItem() {
      //this.loading = true;
      this.$cookies.remove(this.itemId);
      console.log("remove" + this.$cookies.keys());
      if (this.$store.state.cartCounter > 0)
        this.$store.state.cartCounter = this.$store.state.cartCounter - 1;
      this.$destroy();
      this.$parent.updateProducts();
      this.$el.parentNode.removeChild(this.$el);
    }
  }
};
</script>